import { Component } from '@angular/core';
import { StockLocationPromptService } from '../services/stock-location-prompt.service';

@Component({
  selector: 'app-stock-location-prompt',
  template: `
    <div class="location-backdrop" *ngIf="prompt.pending" (keydown.escape)="prompt.cancel()">
      <section role="dialog" aria-modal="true" aria-labelledby="stock-location-title" class="location-dialog">
        <h2 id="stock-location-title">Storage Location required</h2>
        <p>Choose the physical source or destination for this stock change. For an edit or deletion, choose where the resulting stock change occurs.</p>
        <label for="stock-location-choice">Source / destination location</label>
        <select id="stock-location-choice" [(ngModel)]="prompt.selectedId" autofocus>
          <option [ngValue]="0">Choose a location</option>
          <option *ngFor="let location of prompt.locations" [ngValue]="+location.id">{{ location.name }}{{ location.capacity_warning ? ' — Milk capacity warning' : '' }}</option>
        </select>
        <p>All stock changes in this transaction will be attributed to this location.</p>
        <div class="actions">
          <button type="button" (click)="prompt.cancel()">Cancel</button>
          <button type="button" class="primary" [disabled]="!prompt.selectedId" (click)="prompt.confirm()">Confirm and save</button>
        </div>
      </section>
    </div>`,
  styles: [`
    .location-backdrop { position:fixed; inset:0; z-index:100000; background:#0008; display:flex; align-items:center; justify-content:center; padding:1rem }
    .location-dialog { background:var(--surface-card,#fff); color:var(--text-color,#243341); max-width:520px; padding:1.5rem; border-radius:12px; box-shadow:0 15px 50px #0005 }
    label,select { display:block; width:100% } select { padding:.7rem; margin:.5rem 0; border:1px solid #cbd5e1; border-radius:6px }
    .actions { display:flex; justify-content:flex-end; gap:.7rem } button { padding:.65rem 1rem; cursor:pointer; border:1px solid #cbd5e1; border-radius:6px }
    .primary { background:#1565c0; color:white } button:disabled { opacity:.5; cursor:default }
  `]
})
export class StockLocationPromptComponent {
  constructor(public prompt: StockLocationPromptService) {}
}
